<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<button class="toggle-button hinted" [disabled]="disabled" (click)="onClick()">
  <fa name="fa fa-id-card-o"></fa>
  <div class="hint">Profile info, click to Edit</div>
  <template #target></template>
</button>
